import { abyssColors } from '@/theme/colors';
import { Stack, styled as muiStyled } from '@mui/material';

export const Timer = muiStyled(Stack)(() => ({
  borderRadius: '0.4rem',
  padding: '0 0.8rem',
  height: '2.6rem',
  border: `0.1rem solid ${abyssColors.primary[500]}`,
  flexDirection: 'row',
  alignItems: 'center',
}));

export const Duration = muiStyled(Stack)(() => ({
  margin: '0 0.6rem',
  fontSize: '1.2rem',
  lineHeight: 'normal',
  fontWeight: 600,
  color: abyssColors.primary[500],
  paddingTop: '0.2rem',
}));
